"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var velocity_1 = __importDefault(require("../velocity"));
var makeLeftAnimation = function (ref, left, duration, easing) {
    var _a;
    (_a = ref.current) === null || _a === void 0 ? void 0 : _a.animate([{ left: "".concat(left, "px") }], {
        fill: 'forwards',
        duration: duration,
        easing: easing ? 'cubic-bezier(.05,.34,.45,1.08)' : 'linear',
    });
};
var velocity = new velocity_1.default();
var Swipeable = function (props) {
    var trackRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        var _a;
        for (var _i = 0, _b = (_a = trackRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('img'); _i < _b.length; _i++) {
            var img = _b[_i];
            img.draggable = false;
        }
    }, []);
    var start = function (e) {
        var _a, _b;
        if (((_a = trackRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) === ((_b = trackRef.current) === null || _b === void 0 ? void 0 : _b.scrollWidth))
            return;
        var baseLeft = parseInt(getComputedStyle(trackRef.current).left) || 0;
        var baseX = e.clientX ||
            e.touches[0].clientX;
        var moveBinded = move.bind(null, { baseX: baseX, baseLeft: baseLeft });
        window.addEventListener('mousemove', moveBinded);
        window.addEventListener('mouseup', function () {
            window.removeEventListener('mousemove', moveBinded);
            end();
        }, { once: true });
        window.addEventListener('touchmove', moveBinded);
        window.addEventListener('touchend', function () {
            window.removeEventListener('touchmove', moveBinded);
            end();
        }, { once: true });
    };
    var move = function (props, e) {
        var baseX = props.baseX, baseLeft = props.baseLeft;
        var leftMin = -(trackRef.current.scrollWidth -
            trackRef.current.clientWidth);
        var leftMax = 0;
        var clientX = e.clientX || e.touches[0].clientX;
        velocity.updatePosition(clientX);
        var absoluteLeft = baseLeft + clientX - baseX;
        var pullingLeft = absoluteLeft;
        if (absoluteLeft > leftMax) {
            var pull = Math.abs(absoluteLeft - leftMax) / 10;
            pullingLeft = leftMax + pull;
        }
        if (absoluteLeft < leftMin) {
            var pull = Math.abs(absoluteLeft - leftMin) / 10;
            pullingLeft = leftMin - pull;
        }
        makeLeftAnimation(trackRef, pullingLeft, 10);
    };
    var end = function () {
        var leftMin = -(trackRef.current.scrollWidth -
            trackRef.current.clientWidth);
        var leftMax = 0;
        var curLeft = parseInt(getComputedStyle(trackRef.current).left) || 0;
        var vel = velocity.getVelocity();
        velocity.reset();
        if (curLeft > leftMax) {
            makeLeftAnimation(trackRef, leftMax, 200, true);
            return;
        }
        if (curLeft < leftMin) {
            makeLeftAnimation(trackRef, leftMin, 200, true);
            return;
        }
        var absoluteLeft = curLeft + vel / 10;
        var boundedLeft = Math.max(Math.min(absoluteLeft, leftMax), leftMin);
        makeLeftAnimation(trackRef, boundedLeft, 1000, true);
    };
    return (react_1.default.createElement(Container, { className: 'swipeable-container', onTouchStart: start, onMouseDown: start },
        react_1.default.createElement(Track, { ref: trackRef }, props.children)));
};
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  overflow: hidden;\n  user-select: none;\n"], ["\n  overflow: hidden;\n  user-select: none;\n"])));
var Track = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  left: 0px;\n"], ["\n  position: relative;\n  left: 0px;\n"])));
exports.default = Swipeable;
var templateObject_1, templateObject_2;
